import React from "react";
import Header from "../../components/HeaderGreen";
import Footer from "../../components/Footer";
import AboutBanner from "../../components/AboutBanner";
import ContactSection from "../../components/ContactSection";
import SaveSectionAbout from "../../components/About/SaveSectionAbout";
import SectionAbout from "../../components/About/SectionAbout";
import FoundersMessage from "../../components/About/FoundersMessage";
import VisionMission from "../../components/About/VisionMission";
import TeamSection from "../../components/About/TeamSection";
import EndToEndSolutions from "../../components/About/EndToEndSolutions";

function Home() {
  return (
    <>
      <Header />
      <AboutBanner
  title="About Us"
  subtitle="☀️ CM Green Energy India Private Limited"
/>

      <SectionAbout />
      <FoundersMessage />
      <SaveSectionAbout />
      <VisionMission />
      {/* <TeamSection /> */}
      <EndToEndSolutions />
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
